import * as React from 'react';

import { compose } from 'redux';
import { isUBQ, useBubMigration, withTextLocalizer } from 'getaway-data-layer';
import { WithCustomerSupport, WithTextLocalizer } from 'getaway-data-layer';
import BubMigrationView from './BubMigrationView';

type Props = WithTextLocalizer & WithCustomerSupport;

const BubMigrationModal = ({ localize }: Props) => {
  const {
    user,
    showBubModalFlag,
    title,
    description,
    ctaText,
    secondaryCTAText,
    showSecondaryCTA,
    onClose,
    onCTA,
    onSecondaryCTA,
  } = useBubMigration(isUBQ(), true);

  return isUBQ() && showBubModalFlag ? (
    <BubMigrationView
      localize={localize}
      title={title}
      description={description}
      ctaText={ctaText}
      secondaryCTAText={secondaryCTAText}
      onCTA={onCTA}
      onClose={onClose}
      onSecondaryCTA={onSecondaryCTA}
      showSecondaryCTA={showSecondaryCTA}
      showClose={!user}
    />
  ) : null;
};

const withRentalWalkThroughContainer: any = compose(withTextLocalizer);

export default withRentalWalkThroughContainer(BubMigrationModal);
